import moment from 'moment';
export default {
    courseSectionId: 523822,
    contentType: null,
    metrics: [
        {
            courseSectionId: 523822,
            assignmentId: 2532099,
            assignmentName: 'EAQ Novice Pain Management',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT18M49S',
            avgTimeSpentPerQuestion: 'PT45S',
            avgQuestionsAnsweredCorrect: 25.333333333333332,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 1.0,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 21,
            totalStudentsPastDue: 0,
            totalStudents: 21,
            dueDate: '2023-10-30T03:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532094,
            assignmentName: 'EAQ Intermediate Medication Administration',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT56M44S',
            avgTimeSpentPerQuestion: 'PT31S',
            avgQuestionsAnsweredCorrect: 110.0,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.09523809523809523,
            totalStudentsNotStarted: 13,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 2,
            totalStudentsPastDue: 19,
            totalStudents: 21,
            dueDate: '2023-11-06T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532068,
            assignmentName: 'EAQ Oxygenation & Tissue Perfusion Novice',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT14M19S',
            avgTimeSpentPerQuestion: 'PT45S',
            avgQuestionsAnsweredCorrect: 18.526315789473685,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9047619047619048,
            totalStudentsNotStarted: 1,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 19,
            totalStudentsPastDue: 2,
            totalStudents: 21,
            dueDate: '2023-11-23T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532062,
            assignmentName: 'Class activity- Pain NG- Not for a grade',
            assignmentGradeType: 'NOT_GRADED',
            assignmentType: 'AUTHESS',
            gradePoints: 7,
            avgScore: 0.0,
            percentAvgScore: 0.0,
            avgTimeSpent: 'PT0S',
            avgTimeSpentPerQuestion: 'PT0S',
            avgQuestionsAnsweredCorrect: 0.0,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.0,
            totalStudentsNotStarted: 21,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 0,
            totalStudentsPastDue: 0,
            totalStudents: 21,
            dueDate: null,
            isHaveScore: false
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532072,
            assignmentName: 'Class activity: Next Gen Safety Case study (not for a grade)',
            assignmentGradeType: 'NOT_GRADED',
            assignmentType: 'AUTHESS',
            gradePoints: 7,
            avgScore: 0.0,
            percentAvgScore: 0.0,
            avgTimeSpent: 'PT0S',
            avgTimeSpentPerQuestion: 'PT0S',
            avgQuestionsAnsweredCorrect: 0.0,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.0,
            totalStudentsNotStarted: 21,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 0,
            totalStudentsPastDue: 0,
            totalStudents: 21,
            dueDate: null,
            isHaveScore: false
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532073,
            assignmentName: 'Integumentary System and Mucous Membranes: Implement and Take Action; Evaluate',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 29,
            avgScore: 0,
            percentAvgScore: 'NaN',
            avgTimeSpent: 'PT16M30S',
            avgTimeSpentPerQuestion: 'PT34S',
            avgQuestionsAnsweredCorrect: 0,
            avgQuestionsAnsweredIncorrect: 0,
            percentComplete: 0,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 16,
            totalStudentsCompleted: 0,
            totalStudentsPastDue: 0,
            totalStudents: 16,
            dueDate: moment()
                .add(2, 'days')
                .toISOString(),
            isHaveScore: false
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532074,
            assignmentName: 'Urinary Elimination: Implement and Take Action; Evaluate',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.9883040935672515,
            percentAvgScore: 98.83040935672514,
            avgTimeSpent: 'PT3M38S',
            avgTimeSpentPerQuestion: 'PT24S',
            avgQuestionsAnsweredCorrect: 8.894736842105264,
            avgQuestionsAnsweredIncorrect: 0.10526315789473684,
            percentComplete: 0.9047619047619048,
            totalStudentsNotStarted: 1,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 19,
            totalStudentsPastDue: 2,
            totalStudents: 21,
            dueDate: '2023-11-16T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532075,
            assignmentName: 'EAQ Intermediate Hygiene & Personal Care',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT22M16S',
            avgTimeSpentPerQuestion: 'PT1M4S',
            avgQuestionsAnsweredCorrect: 20.94736842105263,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9047619047619048,
            totalStudentsNotStarted: 2,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 19,
            totalStudentsPastDue: 2,
            totalStudents: 21,
            dueDate: '2023-11-06T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532085,
            assignmentName: 'EAQ Novice Medication Administration',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT20M56S',
            avgTimeSpentPerQuestion: 'PT47S',
            avgQuestionsAnsweredCorrect: 26.5,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-10-26T03:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532083,
            assignmentName: 'Medication Administration: Implement and Take Action; Evaluate',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.9789473684210526,
            percentAvgScore: 97.89473684210526,
            avgTimeSpent: 'PT8M38S',
            avgTimeSpentPerQuestion: 'PT27S',
            avgQuestionsAnsweredCorrect: 18.599999999999998,
            avgQuestionsAnsweredIncorrect: 0.40000000000000124,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-10-31T03:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532086,
            assignmentName: 'Nutrition- NG - not for a grade',
            assignmentGradeType: 'NOT_GRADED',
            assignmentType: 'AUTHESS',
            gradePoints: 7,
            avgScore: 0.0,
            percentAvgScore: 0.0,
            avgTimeSpent: 'PT0S',
            avgTimeSpentPerQuestion: 'PT0S',
            avgQuestionsAnsweredCorrect: 0.0,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.0,
            totalStudentsNotStarted: 21,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 0,
            totalStudentsPastDue: 0,
            totalStudents: 21,
            dueDate: null,
            isHaveScore: false
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532088,
            assignmentName: 'EAQ Perioperative Nursing Novice',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT21M9S',
            avgTimeSpentPerQuestion: 'PT53S',
            avgQuestionsAnsweredCorrect: 23.75,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-12-07T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532095,
            assignmentName: 'Fluid Balance: Implement and Take Action; Evaluate',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.9785714285714286,
            percentAvgScore: 97.85714285714286,
            avgTimeSpent: 'PT6M38S',
            avgTimeSpentPerQuestion: 'PT28S',
            avgQuestionsAnsweredCorrect: 13.700000000000001,
            avgQuestionsAnsweredIncorrect: 0.29999999999999893,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 1,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-11-30T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532107,
            assignmentName: 'NG Bowel- not for a grade',
            assignmentGradeType: 'NOT_GRADED',
            assignmentType: 'AUTHESS',
            gradePoints: 7,
            avgScore: 0.0,
            percentAvgScore: 0.0,
            avgTimeSpent: 'PT0S',
            avgTimeSpentPerQuestion: 'PT0S',
            avgQuestionsAnsweredCorrect: 0.0,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.0,
            totalStudentsNotStarted: 21,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 0,
            totalStudentsPastDue: 0,
            totalStudents: 21,
            dueDate: null,
            isHaveScore: false
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532130,
            assignmentName: 'Principles of Safe Medication Administration',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.9541666666666666,
            percentAvgScore: 95.41666666666666,
            avgTimeSpent: 'PT6M13S',
            avgTimeSpentPerQuestion: 'PT31S',
            avgQuestionsAnsweredCorrect: 11.45,
            avgQuestionsAnsweredIncorrect: 0.5500000000000007,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-10-26T03:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532112,
            assignmentName: 'EAQ Elimination Bowel Novice',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT12M32S',
            avgTimeSpentPerQuestion: 'PT42S',
            avgQuestionsAnsweredCorrect: 17.85,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-11-20T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532100,
            assignmentName: 'Nutrition: Assess and Recognize Cues',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.9543478260869568,
            percentAvgScore: 95.43478260869568,
            avgTimeSpent: 'PT12M36S',
            avgTimeSpentPerQuestion: 'PT33S',
            avgQuestionsAnsweredCorrect: 21.950000000000006,
            avgQuestionsAnsweredIncorrect: 1.049999999999994,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-11-13T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532106,
            assignmentName: 'EAQ Sleep Novice',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT18M31S',
            avgTimeSpentPerQuestion: 'PT48S',
            avgQuestionsAnsweredCorrect: 22.9,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-12-07T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532102,
            assignmentName: 'EAQ Intermediate Safety',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT1H4M50S',
            avgTimeSpentPerQuestion: 'PT50S',
            avgQuestionsAnsweredCorrect: 78.0,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.7619047619047619,
            totalStudentsNotStarted: 1,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 16,
            totalStudentsPastDue: 5,
            totalStudents: 21,
            dueDate: '2023-11-06T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532105,
            assignmentName: 'Safety in Nursing Practice',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.990909090909091,
            percentAvgScore: 99.0909090909091,
            avgTimeSpent: 'PT6M8S',
            avgTimeSpentPerQuestion: 'PT33S',
            avgQuestionsAnsweredCorrect: 10.9,
            avgQuestionsAnsweredIncorrect: 0.09999999999999942,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-10-26T03:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532111,
            assignmentName: 'Overview of Surgery',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.8590909090909091,
            percentAvgScore: 85.9090909090909,
            avgTimeSpent: 'PT9M18S',
            avgTimeSpentPerQuestion: 'PT51S',
            avgQuestionsAnsweredCorrect: 9.450000000000001,
            avgQuestionsAnsweredIncorrect: 1.5499999999999996,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-12-07T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532108,
            assignmentName: 'NG urinary- Not for a grade',
            assignmentGradeType: 'NOT_GRADED',
            assignmentType: 'AUTHESS',
            gradePoints: 7,
            avgScore: 0.0,
            percentAvgScore: 0.0,
            avgTimeSpent: 'PT0S',
            avgTimeSpentPerQuestion: 'PT0S',
            avgQuestionsAnsweredCorrect: 0.0,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.0,
            totalStudentsNotStarted: 21,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 0,
            totalStudentsPastDue: 0,
            totalStudents: 21,
            dueDate: null,
            isHaveScore: false
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532125,
            assignmentName: 'EAQ Novice Safety',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT10M59S',
            avgTimeSpentPerQuestion: 'PT41S',
            avgQuestionsAnsweredCorrect: 16.2,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-10-26T03:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532120,
            assignmentName: 'Skin Integrity and Wound Care: Implement and Take Action; Evaluate',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.7500000000000001,
            percentAvgScore: 75.0,
            avgTimeSpent: 'PT4M40S',
            avgTimeSpentPerQuestion: 'PT14S',
            avgQuestionsAnsweredCorrect: 19.0,
            avgQuestionsAnsweredIncorrect: 0.9999999999999987,
            percentComplete: 0.2857142857142857,
            totalStudentsNotStarted: 7,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 6,
            totalStudentsPastDue: 15,
            totalStudents: 21,
            dueDate: '2023-11-05T03:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532126,
            assignmentName: 'EAQ Fluid, Electrolytes & Acid-Base Balance Novice',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT18M48S',
            avgTimeSpentPerQuestion: 'PT47S',
            avgQuestionsAnsweredCorrect: 24.1,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 1,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-11-30T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532132,
            assignmentName: 'Electrolyte Imbalance',
            assignmentGradeType: 'NOT_GRADED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.0,
            percentAvgScore: 0.0,
            avgTimeSpent: 'PT0S',
            avgTimeSpentPerQuestion: 'PT0S',
            avgQuestionsAnsweredCorrect: 0.0,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.0,
            totalStudentsNotStarted: 21,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 0,
            totalStudentsPastDue: 0,
            totalStudents: 21,
            dueDate: null,
            isHaveScore: false
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532134,
            assignmentName: 'Overview of Fluid Balance',
            assignmentGradeType: 'NOT_GRADED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.0,
            percentAvgScore: 0.0,
            avgTimeSpent: 'PT0S',
            avgTimeSpentPerQuestion: 'PT0S',
            avgQuestionsAnsweredCorrect: 0.0,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.0,
            totalStudentsNotStarted: 21,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 0,
            totalStudentsPastDue: 0,
            totalStudents: 21,
            dueDate: null,
            isHaveScore: false
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532113,
            assignmentName: 'Pain Management: Implement and Take Action; Evaluate',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.9557823129251701,
            percentAvgScore: 95.57823129251702,
            avgTimeSpent: 'PT6M23S',
            avgTimeSpentPerQuestion: 'PT27S',
            avgQuestionsAnsweredCorrect: 13.380952380952381,
            avgQuestionsAnsweredIncorrect: 0.6190476190476182,
            percentComplete: 1.0,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 21,
            totalStudentsPastDue: 0,
            totalStudents: 21,
            dueDate: '2023-10-30T03:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532078,
            assignmentName: 'EAQ Novice Hygiene & Personal Care',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT12M31S',
            avgTimeSpentPerQuestion: 'PT40S',
            avgQuestionsAnsweredCorrect: 18.523809523809526,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 1.0,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 21,
            totalStudentsPastDue: 0,
            totalStudents: 21,
            dueDate: '2023-10-30T03:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532123,
            assignmentName: 'EAQ Proficient Pain Management',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT1H33M22S',
            avgTimeSpentPerQuestion: 'PT27S',
            avgQuestionsAnsweredCorrect: 207.33333333333334,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.14285714285714285,
            totalStudentsNotStarted: 13,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 3,
            totalStudentsPastDue: 18,
            totalStudents: 21,
            dueDate: '2023-11-06T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532058,
            assignmentName: 'Mobility In class activity- not for a grade',
            assignmentGradeType: 'NOT_GRADED',
            assignmentType: 'AUTHESS',
            gradePoints: 7,
            avgScore: 0.0,
            percentAvgScore: 0.0,
            avgTimeSpent: 'PT0S',
            avgTimeSpentPerQuestion: 'PT0S',
            avgQuestionsAnsweredCorrect: 0.0,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.0,
            totalStudentsNotStarted: 21,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 0,
            totalStudentsPastDue: 0,
            totalStudents: 21,
            dueDate: null,
            isHaveScore: false
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532060,
            assignmentName: 'Activity and Movement: Implement and Take Action; Evaluate',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.9714285714285715,
            percentAvgScore: 97.14285714285715,
            avgTimeSpent: 'PT8M43S',
            avgTimeSpentPerQuestion: 'PT25S',
            avgQuestionsAnsweredCorrect: 20.400000000000002,
            avgQuestionsAnsweredIncorrect: 0.5999999999999979,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 1,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-11-09T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2591202,
            assignmentName: 'EAQ intermediate Medication Administration',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT34M45S',
            avgTimeSpentPerQuestion: 'PT55S',
            avgQuestionsAnsweredCorrect: 37.65,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 1,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-11-06T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2591227,
            assignmentName: 'EAQ intermediate Pain Management',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT18M22S',
            avgTimeSpentPerQuestion: 'PT1M9S',
            avgQuestionsAnsweredCorrect: 15.947368421052632,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9047619047619048,
            totalStudentsNotStarted: 1,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 19,
            totalStudentsPastDue: 2,
            totalStudents: 21,
            dueDate: '2023-11-06T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2591231,
            assignmentName: 'EAQ intermediate Skin Integrity & Wound Care',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT29M35S',
            avgTimeSpentPerQuestion: 'PT55S',
            avgQuestionsAnsweredCorrect: 31.6,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-11-06T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532122,
            assignmentName: 'EAQ Activity, Immobility, & Safe Movement-Novice',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT14M48S',
            avgTimeSpentPerQuestion: 'PT40S',
            avgQuestionsAnsweredCorrect: 21.75,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-11-09T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532103,
            assignmentName: 'EAQ Nutrition Novice',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT10M15S',
            avgTimeSpentPerQuestion: 'PT32S',
            avgQuestionsAnsweredCorrect: 18.95,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-11-13T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532067,
            assignmentName: 'Nutrition: Implement and Take Action; Evaluate',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.9757085020242916,
            percentAvgScore: 97.57085020242916,
            avgTimeSpent: 'PT7M45S',
            avgTimeSpentPerQuestion: 'PT36S',
            avgQuestionsAnsweredCorrect: 12.684210526315791,
            avgQuestionsAnsweredIncorrect: 0.3157894736842092,
            percentComplete: 0.9047619047619048,
            totalStudentsNotStarted: 1,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 19,
            totalStudentsPastDue: 2,
            totalStudents: 21,
            dueDate: '2023-11-13T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532119,
            assignmentName: 'EAQ Intermediate Nutrition',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT27M28S',
            avgTimeSpentPerQuestion: 'PT1M3S',
            avgQuestionsAnsweredCorrect: 26.05,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-11-27T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532059,
            assignmentName: 'EAQ Elimination Urinary Novice',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT22M41S',
            avgTimeSpentPerQuestion: 'PT1M2S',
            avgQuestionsAnsweredCorrect: 22.105263157894736,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9047619047619048,
            totalStudentsNotStarted: 1,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 19,
            totalStudentsPastDue: 2,
            totalStudents: 21,
            dueDate: '2023-11-16T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532071,
            assignmentName: 'Bowel Elimination: Implement and Take Action; Evaluate',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.9666666666666668,
            percentAvgScore: 96.66666666666669,
            avgTimeSpent: 'PT14M40S',
            avgTimeSpentPerQuestion: 'PT37S',
            avgQuestionsAnsweredCorrect: 23.200000000000003,
            avgQuestionsAnsweredIncorrect: 0.7999999999999972,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-11-20T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532087,
            assignmentName: 'EAQ Intermediate Activity, Immobility, & Safe Movement',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT22M43S',
            avgTimeSpentPerQuestion: 'PT44S',
            avgQuestionsAnsweredCorrect: 30.95,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-11-27T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532069,
            assignmentName: 'EAQ Intermediate Urinary',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT17M46S',
            avgTimeSpentPerQuestion: 'PT43S',
            avgQuestionsAnsweredCorrect: 25.05263157894737,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9047619047619048,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 19,
            totalStudentsPastDue: 2,
            totalStudents: 21,
            dueDate: '2023-11-27T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532133,
            assignmentName: 'Sleep: Implement and Take Action; Evaluate',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.9875,
            percentAvgScore: 98.75,
            avgTimeSpent: 'PT3M52S',
            avgTimeSpentPerQuestion: 'PT29S',
            avgQuestionsAnsweredCorrect: 7.9,
            avgQuestionsAnsweredIncorrect: 0.09999999999999964,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-12-07T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532079,
            assignmentName: 'Cognition and Sensation: Implement and Take Action; Evaluate',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.7903381642512079,
            percentAvgScore: 79.03381642512079,
            avgTimeSpent: 'PT10M28S',
            avgTimeSpentPerQuestion: 'PT27S',
            avgQuestionsAnsweredCorrect: 18.7,
            avgQuestionsAnsweredIncorrect: 4.83,
            percentComplete: 0.65,
            totalStudentsNotStarted: 1,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 18,
            totalStudentsPastDue: 3,
            totalStudents: 21,
            dueDate: '2023-12-04T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532089,
            assignmentName: 'Oxygenation and Perfusion: Implement and Take Action; Evaluate',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.9597523219814241,
            percentAvgScore: 95.97523219814241,
            avgTimeSpent: 'PT11M39S',
            avgTimeSpentPerQuestion: 'PT41S',
            avgQuestionsAnsweredCorrect: 16.31578947368421,
            avgQuestionsAnsweredIncorrect: 0.6842105263157898,
            percentComplete: 0.9047619047619048,
            totalStudentsNotStarted: 1,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 19,
            totalStudentsPastDue: 2,
            totalStudents: 21,
            dueDate: '2023-11-23T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532070,
            assignmentName: 'Overview of Electrolyte Balance',
            assignmentGradeType: 'NOT_GRADED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.0,
            percentAvgScore: 0.0,
            avgTimeSpent: 'PT0S',
            avgTimeSpentPerQuestion: 'PT0S',
            avgQuestionsAnsweredCorrect: 0.0,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.0,
            totalStudentsNotStarted: 21,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 0,
            totalStudentsPastDue: 0,
            totalStudents: 21,
            dueDate: null,
            isHaveScore: false
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532128,
            assignmentName: 'EAQ Cognition & Sensation Alterations Novice',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT15M57S',
            avgTimeSpentPerQuestion: 'PT48S',
            avgQuestionsAnsweredCorrect: 20.0,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.8571428571428571,
            totalStudentsNotStarted: 1,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 18,
            totalStudentsPastDue: 3,
            totalStudents: 21,
            dueDate: '2023-12-04T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532063,
            assignmentName: 'EAQ Intermediate Asepsis & Infection Control',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT17M30S',
            avgTimeSpentPerQuestion: 'PT58S',
            avgQuestionsAnsweredCorrect: 17.842105263157894,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9047619047619048,
            totalStudentsNotStarted: 1,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 19,
            totalStudentsPastDue: 2,
            totalStudents: 21,
            dueDate: '2023-11-06T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532066,
            assignmentName: 'Spread of Infection',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.9888888888888889,
            percentAvgScore: 98.88888888888889,
            avgTimeSpent: 'PT2M23S',
            avgTimeSpentPerQuestion: 'PT16S',
            avgQuestionsAnsweredCorrect: 8.9,
            avgQuestionsAnsweredIncorrect: 0.09999999999999964,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 1,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-11-02T03:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532080,
            assignmentName: 'Infection and Infection Control: Implement and Take Action; Evaluate',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.9649122807017545,
            percentAvgScore: 96.49122807017545,
            avgTimeSpent: 'PT9M24S',
            avgTimeSpentPerQuestion: 'PT24S',
            avgQuestionsAnsweredCorrect: 23.15789473684211,
            avgQuestionsAnsweredIncorrect: 0.842105263157892,
            percentComplete: 0.9047619047619048,
            totalStudentsNotStarted: 1,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 19,
            totalStudentsPastDue: 2,
            totalStudents: 21,
            dueDate: '2023-11-02T03:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532093,
            assignmentName: 'EAQ Asepsis & Infection Control',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT14M43S',
            avgTimeSpentPerQuestion: 'PT42S',
            avgQuestionsAnsweredCorrect: 20.85,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-11-02T03:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532061,
            assignmentName: 'EAQ Intermediate Skin Integrity & Wound Care',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT29M44S',
            avgTimeSpentPerQuestion: 'PT13S',
            avgQuestionsAnsweredCorrect: 136.0,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.09523809523809523,
            totalStudentsNotStarted: 12,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 2,
            totalStudentsPastDue: 19,
            totalStudents: 21,
            dueDate: '2023-11-06T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532116,
            assignmentName: 'EAQ Intermediate Bowel',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT20M57S',
            avgTimeSpentPerQuestion: 'PT48S',
            avgQuestionsAnsweredCorrect: 26.42105263157895,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9047619047619048,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 19,
            totalStudentsPastDue: 2,
            totalStudents: 21,
            dueDate: '2023-11-27T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2573030,
            assignmentName: 'Skin Integrity and Wound Care: Implement and Take Action; Evaluate',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.9775,
            percentAvgScore: 97.75,
            avgTimeSpent: 'PT6M38S',
            avgTimeSpentPerQuestion: 'PT20S',
            avgQuestionsAnsweredCorrect: 19.55,
            avgQuestionsAnsweredIncorrect: 0.4499999999999993,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 1,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-11-02T03:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532118,
            assignmentName: 'EAQ Skin Integrity & Wound Care',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT14M53S',
            avgTimeSpentPerQuestion: 'PT41S',
            avgQuestionsAnsweredCorrect: 22.0,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-11-02T03:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532131,
            assignmentName: 'Fluid Imbalance',
            assignmentGradeType: 'NOT_GRADED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.0,
            percentAvgScore: 0.0,
            avgTimeSpent: 'PT0S',
            avgTimeSpentPerQuestion: 'PT0S',
            avgQuestionsAnsweredCorrect: 0.0,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.0,
            totalStudentsNotStarted: 21,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 0,
            totalStudentsPastDue: 0,
            totalStudents: 21,
            dueDate: null,
            isHaveScore: false
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532104,
            assignmentName: 'Electrolyte Balance: Implement and Take Action; Evaluate',
            assignmentGradeType: 'SCORED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.9666666666666666,
            percentAvgScore: 96.66666666666666,
            avgTimeSpent: 'PT4M11S',
            avgTimeSpentPerQuestion: 'PT21S',
            avgQuestionsAnsweredCorrect: 11.599999999999998,
            avgQuestionsAnsweredIncorrect: 0.40000000000000124,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 1,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-11-30T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532084,
            assignmentName: 'Overview of Loss and Grief (Recommended for HESI prep)',
            assignmentGradeType: 'NOT_GRADED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.8916666666666666,
            percentAvgScore: 89.16666666666666,
            avgTimeSpent: 'PT21M33S',
            avgTimeSpentPerQuestion: 'PT1M5S',
            avgQuestionsAnsweredCorrect: 17.833333333333332,
            avgQuestionsAnsweredIncorrect: 2.166666666666668,
            percentComplete: 0.2857142857142857,
            totalStudentsNotStarted: 13,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 6,
            totalStudentsPastDue: 15,
            totalStudents: 21,
            dueDate: '2023-12-14T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532081,
            assignmentName: 'Overview of Stress and Coping (Recommended for HESI prep)',
            assignmentGradeType: 'NOT_GRADED',
            assignmentType: 'LESSONS',
            gradePoints: 100,
            avgScore: 0.8666666666666666,
            percentAvgScore: 86.66666666666666,
            avgTimeSpent: 'PT14M17S',
            avgTimeSpentPerQuestion: 'PT57S',
            avgQuestionsAnsweredCorrect: 12.999999999999998,
            avgQuestionsAnsweredIncorrect: 2.0000000000000013,
            percentComplete: 0.3333333333333333,
            totalStudentsNotStarted: 12,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 7,
            totalStudentsPastDue: 14,
            totalStudents: 21,
            dueDate: '2023-12-14T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532065,
            assignmentName: 'EAQ Intermediate Fluid, Electrolyes, Acid-Base Balance',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT34M8S',
            avgTimeSpentPerQuestion: 'PT50S',
            avgQuestionsAnsweredCorrect: 41.3,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-12-11T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532092,
            assignmentName: 'EAQ Intermediate Cognition & Sensory Alteration',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT28M57S',
            avgTimeSpentPerQuestion: 'PT53S',
            avgQuestionsAnsweredCorrect: 32.9,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9523809523809523,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 20,
            totalStudentsPastDue: 1,
            totalStudents: 21,
            dueDate: '2023-12-11T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532090,
            assignmentName: 'EAQ Intermediate Oxygenation & Tissue Perfusion',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT16M24S',
            avgTimeSpentPerQuestion: 'PT47S',
            avgQuestionsAnsweredCorrect: 21.473684210526315,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9047619047619048,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 19,
            totalStudentsPastDue: 2,
            totalStudents: 21,
            dueDate: '2023-12-11T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532110,
            assignmentName: 'EAQ Intermediate Perioperative Nursing',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT40M25S',
            avgTimeSpentPerQuestion: 'PT1M4S',
            avgQuestionsAnsweredCorrect: 37.94736842105263,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9047619047619048,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 19,
            totalStudentsPastDue: 2,
            totalStudents: 21,
            dueDate: '2023-12-11T04:59:00Z',
            isHaveScore: true
        },
        {
            courseSectionId: 523822,
            assignmentId: 2532098,
            assignmentName: 'EAQ Intermediate Sleep',
            assignmentGradeType: 'PASS_FAIL',
            assignmentType: 'MASTERY',
            gradePoints: 1,
            avgScore: 1.0,
            percentAvgScore: 100.0,
            avgTimeSpent: 'PT15M46S',
            avgTimeSpentPerQuestion: 'PT39S',
            avgQuestionsAnsweredCorrect: 23.526315789473685,
            avgQuestionsAnsweredIncorrect: 0.0,
            percentComplete: 0.9047619047619048,
            totalStudentsNotStarted: 0,
            totalStudentsInProgress: 0,
            totalStudentsCompleted: 19,
            totalStudentsPastDue: 2,
            totalStudents: 21,
            dueDate: '2023-12-11T04:59:00Z',
            isHaveScore: true
        }
    ],
    cardData: {
        completedAssignments: 49,
        below85percentAssignments: 2,
        pastDueAssignments: 1,
        totalAssignments: 65,
        classAvgScore: null,
        totalStudents: null,
        pastDueStudents: null,
        belowClassAvgStudents: null,
        inProgressAssignment: 6
    },
    listContentTypeAvailable: ['MASTERY', 'LESSONS', 'AUTHESS']
};
